export default {
    init() {
        const accordionButtons = document.querySelectorAll(".accordion-button");

        if (!accordionButtons) {
            return;
        }

        accordionButtons.forEach(button => {
            const panelId = button.getAttribute("aria-controls");
            const panel = document.getElementById(panelId);

            button.addEventListener("click", () => {
                const isExpanded = button.getAttribute("aria-expanded") === "true";

                // Close all other buttons and panels
                accordionButtons.forEach(btn => {
                    const otherPanelId = btn.getAttribute("aria-controls");
                    const otherPanel = document.getElementById(otherPanelId);
                    btn.setAttribute("aria-expanded", "false");
                    btn.querySelector(".open-icon").classList.remove("rotated");
                    btn.querySelector(".open-icon").classList.remove("active");
                    otherPanel.style.maxHeight = "0";
                });

                // If it was not expanded, expand it
                if (!isExpanded) {
                    button.setAttribute("aria-expanded", "true");
                    button.querySelector(".open-icon").classList.toggle("rotated");
                    button.classList.toggle("active");
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });

            // Optional: keyboard accessibility
            button.addEventListener("keydown", event => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    button.click();
                }
            });
        });

        window.addEventListener("resize", () => {
            document.querySelectorAll(".accordion-button[aria-expanded=\"true\"]").forEach(button => {
                const panelId = button.getAttribute("aria-controls");
                const panel = document.getElementById(panelId);
                panel.style.maxHeight = panel.scrollHeight + "px";
            });
        });
    },
}
